import { BillingReportRow } from '../../types';

export interface Props {
  rows: BillingReportRow[];
  onDismiss: () => void;
  afterSave: ({ refresh }: { refresh: boolean }) => void;
}

export interface BillingItemEdit {
  field_edits: FieldEdit[];
  notes: string;
  billing_item_ids: string[];
}

export interface FieldEdit {
  id: string;
  edit_type: string;
  value: string | number | string[];
}

export const FieldEditTypeSlugs = {
  add_modifiers: 'add_modifiers',
  remove_modifiers: 'remove_modifiers',
  set_destination: 'set_destination',
  set_modifiers: 'set_modifiers',
  set_units: 'set_units',
  set_rate: 'set_rate',
  set_jurisdiction: 'set_jurisdiction',
  set_cpt_code: 'set_cpt_code',
  set_rendering_provider: 'set_rendering_provider',
  set_case_rate_rule: 'set_case_rate_rule',
  mark_unbillable: 'mark_unbillable'
};

export const FieldEditTypes = [
  {
    slug: FieldEditTypeSlugs.add_modifiers,
    name: 'Add Modifiers',
    description: 'Add these modifiers to every item if not present. Comma separated'
  },
  {
    slug: FieldEditTypeSlugs.remove_modifiers,
    name: 'Remove Modifier',
    description: 'Remove these modifiers from every item if present'
  },
  {
    slug: FieldEditTypeSlugs.set_modifiers,
    name: 'Set Modifiers',
    description: 'Set the modifiers for every item, overwriting any existing modifiers'
  },
  {
    slug: FieldEditTypeSlugs.set_destination,
    name: 'Set Destination',
    description: 'Set the destination for every item, overwriting any existing destination'
  },
  {
    slug: FieldEditTypeSlugs.set_units,
    name: 'Set Units',
    description: 'Set the units for every item'
  },
  {
    slug: FieldEditTypeSlugs.set_rate,
    name: 'Set Rate',
    description: 'Set the rate for every item'
  },
  {
    slug: FieldEditTypeSlugs.set_jurisdiction,
    name: 'Set Jurisdiction',
    description: 'Set the jurisdiction for every item'
  },
  {
    slug: FieldEditTypeSlugs.set_case_rate_rule,
    name: 'Set Case Rate Rule',
    description: 'Set the case rate rule for every item'
  },
  {
    slug: FieldEditTypeSlugs.set_cpt_code,
    name: 'Set CPT Code',
    description: 'Set the CPT code for every item'
  },
  {
    slug: FieldEditTypeSlugs.set_rendering_provider,
    name: 'Set Rendering Provider',
    description: 'Set the rendering provider for every item'
  },
  {
    slug: FieldEditTypeSlugs.mark_unbillable,
    name: 'Mark Unbillable',
    description: 'Marks every item as unbillable'
  }
];

export interface BillingItemEditGroup {
  id: number;
  by: string;
  at: string;
}
